import { Link } from "react-router-dom";
import { BadgePercent, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { AmbientBackground } from "./AmbientBackground";
import { MonthlyCard, YearlyCard } from "./PricingCards";

const PricingHeader = () => (
  <header className="relative z-[1] border-b border-[#C4A36A]/25 bg-[#F7F3EA]">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
      <Link to="/" className="flex items-center gap-3" data-testid="pricing-logo">
        <img src="/assets/hero-crest.png?v=2" alt="" className="h-10 w-auto" />
        <span className="font-serif text-sm font-medium uppercase tracking-[0.22em] text-[#A08448]">
          Community Hearts
        </span>
      </Link>
      <Link
        to="/"
        className="text-[11px] font-medium uppercase tracking-[0.18em] text-[#A08448] transition-colors hover:text-[#7A5A14]"
        data-testid="pricing-back-link"
      >
        Back to the site
      </Link>
    </div>
  </header>
);

const PricingFootnotes = () => (
  <>
    <Reveal delay={0.3} className="mt-12 text-center">
      <p className="text-xs uppercase tracking-[0.2em] text-[#5C5346]" data-testid="pricing-note">
        Founding membership is arranged through PayPal ·{" "}
        <Link to="/refund-policy" className="text-gold underline-offset-4 hover:underline" data-testid="pricing-refund-link">
          Cancel anytime
        </Link>
      </p>
    </Reveal>
    <Reveal delay={0.35} className="mt-8 text-center">
      <p className="inline-flex items-center gap-2 text-sm text-[#5C5346]">
        <ShieldCheck className="h-4 w-4 text-gold" />
        Every member is photo-verified before their first match.{" "}
        <Link to="/safety" className="font-semibold text-gold underline-offset-4 hover:underline" data-testid="pricing-safety-link">
          Read our Safety promise
        </Link>
      </p>
    </Reveal>
  </>
);

const PricingPage = () => {
  return (
    <div className="dark-landing min-h-screen overflow-x-clip bg-[#16233D] font-sans text-cream" data-testid="pricing-page">
      <AmbientBackground />
      <PricingHeader />
      <main className="relative z-[1] bg-[#F7F1E6]">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <Reveal className="text-center">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-[#5C5346]" data-testid="pricing-overline">Hearts+ membership</p>
          <h1 className="mx-auto max-w-2xl font-serif text-4xl leading-tight tracking-tight text-[#1C1612] md:text-6xl" data-testid="pricing-headline">
            One membership. <span className="italic text-gold">Two ways in.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-[#5C5346] md:text-lg">
            Founding membership is arranged through PayPal.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-10 flex justify-center">
          <p className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-5 py-2.5 text-center text-xs font-bold uppercase tracking-[0.15em] text-gold" data-testid="pricing-founding-banner">
            <BadgePercent className="h-4 w-4 shrink-0" />
            Founding member deal — 50% off your first year, limited time
          </p>
        </Reveal>

        <div className="mx-auto mt-16 grid max-w-4xl gap-8 md:grid-cols-2 md:gap-10">
          <Reveal delay={0.1}>
            <MonthlyCard />
          </Reveal>
          <Reveal delay={0.2}>
            <YearlyCard />
          </Reveal>
        </div>

        <PricingFootnotes />
        </div>
      </main>
    </div>
  );
};

export default PricingPage;
